import { Button } from "@components/buttons/button";
import { Close } from "@components/buttons/close";
import { IToastifyTypeDTO } from "@hooks/dtos/toastify-dto";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { useEffect, useState } from "react";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  header: string;
  title: string;
  text: string;
}

export function ModalInfo({ isOpen, onClose, header, title, text }: IProps) {
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [animate, setAnimate] = useState(false);
  const [message, setMessage] = useState<{
    text: string;
    type: IToastifyTypeDTO;
  }>();

  function handleClose() {
    setAnimate(false);
    setTimeout(() => onClose(), 300);
  }

  function handleEscape(evt: KeyboardEvent) {
    if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
      handleClose();
    }
  }

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setAnimate(true), 10);
      document.addEventListener("keydown", handleEscape);

      // --- Event Listener for Messages by HTML --- //
      const handleModalMessage = (event: any) => {
        setMessage({
          text: event.detail.text,
          type: event.detail.type,
        });
      };

      window.addEventListener("modalMessage", handleModalMessage);

      return () => {
        document.removeEventListener("keydown", handleEscape);
      };
    } else {
      setAnimate(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      if (message && message.text) {
        pushToastify({
          message: message.text,
          type: message.type || "info",
          theme: "dark",
        });

        setMessage({ text: "", type: "info" });
      }
    }
  }, [message]);

  return (
    <>
      <div
        className={`modal fade ${animate && isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
        aria-labelledby="staticBackdropLabel"
        aria-hidden={!isOpen}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold" id="contentModallLabel">
                {header}
              </h5>
              <Close onPress={handleClose} />
            </div>
            <div className="modal-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className="row gap-3">
                  <div className="col-md-12 col-12">
                    <h5 className="modal-title">{title}</h5>
                  </div>
                  <div className="col-md-12 mb-2 col-12">
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                  </div>
                  <div className="col-md-12 mb-2 col-12 text-end">
                    <Button
                      onClick={handleClose}
                      children="Entendido"
                      className="btn btn-primary py-2 px-5"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal-backdrop fade ${animate && isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
      ></div>
    </>
  );
}
